/**
 * Caché de sesión del contenido de carpetas, por ruta.
 *
 * Hoy bajar a una subcarpeta y volver con el breadcrumb relee todo, y eso pasa
 * en cada paso de navegación. Con esto, volver a una carpeta ya visitada en la
 * sesión no cuesta ninguna lectura.
 *
 * Vive en memoria del módulo, así que muere con la pestaña. NO usa
 * localStorage ni IndexedDB: dejar metadato de documentos (nombres, URLs de
 * Storage) en el disco de máquinas posiblemente compartidas es una decisión de
 * seguridad aparte, no un efecto colateral de una optimización.
 *
 * SOLO DATOS. Nunca guardar JSX aquí: cachear elementos React congela los
 * closures de permisos (isRoot, isAdmin, roles) y el usuario acabaría viendo
 * botones con permisos viejos. El JSX se reconstruye en cada carga; es barato.
 *
 * Regla de invalidación: mutación invalida, navegación no. En la vista clásica
 * eso son los flujos que ponen `isLoad: true` (subir, borrar, cerrar, abrir,
 * permisos), que recargan con `{ force: true }`.
 */

const cache = new Map();

/**
 * @param {string} path  ruta de la CollectionReference de la carpeta
 * @returns {{folderData: object, fileRows: object[]}|null}
 */
export const getFolderCache = (path) => {
  if (typeof path !== 'string' || !path) return null;
  return cache.get(path) || null;
};

/**
 * @param {string} path
 * @param {object} value  { folderData, fileRows } — datos, nunca JSX
 */
export const setFolderCache = (path, value) => {
  if (typeof path !== 'string' || !path || !value) return;
  cache.set(path, value);
};

export const invalidateFolder = (path) => {
  if (typeof path !== 'string' || !path) return;
  cache.delete(path);
};

export const invalidateAll = () => cache.clear();

/** Solo para tests y diagnóstico. */
export const cacheSize = () => cache.size;
